import { I18nProvider, Toast } from '@metadevprofile/ui/web';
import { useTranslation } from 'react-i18next';
import { useThemeManager } from '@/common/hooks/use-theme-manager';

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const { i18n } = useTranslation();
  useThemeManager();

  const locale = i18n.language === 'FR' ? 'fr-FR' : 'en-US';

  return (
    <I18nProvider locale={locale}>
      {children}
      <Toast.Provider placement="top end" />
    </I18nProvider>
  );
}
